import React, { Fragment } from 'react';
import {
  firebaseConfig,
  vapidKey,
  serviceWorkerFile
} from 'gatsby-env-variables';
import 'firebase/messaging';
import { sendDeviceIdAndFCMToken } from '../../common/constants/api';
import { setFcm, getFcm } from '../../common/utils/firebase-utils';
import { Toast } from '@fincity-frontend/shared-ui';
import firebase from 'firebase/app';
import notification from '../../Audio/notification/notification_call.mp3';

export const initiaizeFB = () => {
  if (firebase.apps.length === 0) {
    return firebase.initializeApp(firebaseConfig);
  }
};

export const messaging = () => firebase.messaging();

const sendTokenAndCred = ({ deviceInfo, deviceId, currentToken }) => {
  let isMobileLikeDevice =
    deviceInfo?.device?.type == 'smartphone' ||
    deviceInfo?.device?.type == 'tablet' ||
    deviceInfo?.device?.type == 'phablet';
  sendDeviceIdAndFCMToken({
    isMobileDevice: isMobileLikeDevice,
    deviceId: deviceId,
    FCMToken: currentToken,
    deviceInfo: deviceInfo
  }).catch(error => {});
};

export const isFcmServiceWorkerActive = async () =>
  await navigator.serviceWorker
    .getRegistration(serviceWorkerFile)
    .then(function(registration) {
      if (registration?.active?.state == 'activated') {
        return true;
      }
      return false;
    });
export const getToken = async ({
  setFirebaseToken,
  deviceInfo,
  deviceId,
  setShowNotificationHeader,
  setShowNotificationHeaderMessage
}) => {
  return messaging()
    .getToken({
      vapidKey: vapidKey
    })
    .then(async currentToken => {
      if (currentToken) {
        sendTokenAndCred({ deviceInfo, deviceId, currentToken });
        setFirebaseToken(currentToken);
        setFcm({ ...(getFcm() || {}), fcmToken: currentToken });
      }
    })
    .catch(async err => {
      setShowNotificationHeader(true);
      setShowNotificationHeaderMessage(err?.message);
    });
};
export const onMessageListener = () =>
  messaging()?.onMessage(payload => {
    const audio = new Audio(notification);
    audio.play();

    Toast(
      'info',
      <Fragment>
        <span className="pb-1 font-semibold font-roboto text-white text-base px-1 ">
          {payload?.notification?.title || 'New Notification'}
        </span>
        <p className="pb-1 font-normal font-roboto text-white text-base px-3 mt-2">
          {payload.notification.body || 'You recieved a new notification!'}
        </p>
      </Fragment>,
      20000,
      'top-right'
    );
  });
